module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_vm._m(0), _vm._v(" "), _c('div', {
    ref: "stage",
    staticClass: "hub intro-y mt-5",
    on: {
      "pointermove": _vm.onMove,
      "pointerleave": _vm.onLeave
    }
  }, [_c('div', {
    ref: "world",
    staticClass: "world"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "face floor floor-bg"
  }), _vm._v(" "), _vm._l((_vm.walls), function(wall) {
    return _c('div', {
      key: wall.id,
      staticClass: "face wall-bg",
      class: wall.id
    }, _vm._l((_vm.doorsOn(wall.id)), function(door, k) {
      return _c('button', {
        key: door.name,
        staticClass: "door",
        style: ({
          left: _vm.slotLeft(wall, k) + 'px'
        }),
        attrs: {
          "type": "button",
          "aria-label": 'Abrir ' + door.name,
          "title": door.description,
          "disabled": _vm.busy
        },
        on: {
          "mouseenter": function($event) {
            _vm.hovered = door.name
          },
          "mouseleave": function($event) {
            _vm.hovered = null
          },
          "focus": function($event) {
            _vm.hovered = door.name
          },
          "blur": function($event) {
            _vm.hovered = null
          },
          "click": function($event) {
            return _vm.enter(door)
          }
        }
      }, [_c('span', {
        staticClass: "sign",
        class: {
          'sign--active': _vm.isActive(door)
        }
      }, [_vm._v(_vm._s(door.name))]), _vm._v(" "), _c('span', {
        staticClass: "frame"
      }, [_c('span', {
        staticClass: "hole"
      }), _vm._v(" "), _c('span', {
        staticClass: "glow",
        style: ({
          opacity: _vm.glowOpacity(door)
        })
      }), _vm._v(" "), _c('span', {
        staticClass: "peek-wrap"
      }, [_c('span', {
        staticClass: "peek",
        style: (_vm.peekStyle(door)),
        domProps: {
          "innerHTML": _vm._s(_vm.icon(door.icon, 40))
        }
      })]), _vm._v(" "), _c('span', {
        staticClass: "leaf",
        style: (_vm.leafStyle(door))
      }, [_c('span', {
        staticClass: "leaf-icon",
        style: (_vm.iconStyle(door)),
        domProps: {
          "innerHTML": _vm._s(_vm.icon(door.icon, 32))
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "leaf-line"
      }), _vm._v(" "), _c('span', {
        staticClass: "leaf-line"
      }), _vm._v(" "), _c('span', {
        staticClass: "knob"
      })])])])
    }), 0)
  })], 2), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.overlay) ? _c('div', {
    staticClass: "overlay"
  }, [_c('div', {
    staticClass: "overlay-icon",
    domProps: {
      "innerHTML": _vm._s(_vm.icon(_vm.overlay.icon, 48))
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "overlay-title"
  }, [_vm._v("Abriendo " + _vm._s(_vm.overlay.name) + "…")]), _vm._v(" "), _c('p', {
    staticClass: "overlay-text"
  }, [_vm._v(_vm._s(_vm.overlay.description))]), _vm._v(" "), _c('div', {
    staticClass: "overlay-bar"
  }, [_c('div', {
    staticClass: "overlay-bar__fill"
  })])]) : _vm._e()])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "intro-y grid grid-cols-12 gap-3 sm:gap-6 mt-5"
  }, [_c('div', {
    staticClass: "col-span-12"
  }, [_c('h2', {
    staticClass: "intro-y text-lg font-medium mr-auto mt-2"
  }, [_vm._v("Plataformas")]), _vm._v(" "), _c('p', {
    staticClass: "text-gray-600 text-xs mt-1"
  }, [_vm._v("Pasa el mouse sobre una puerta para abrirla · Clic para entrar")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "face ceil ceil-bg"
  }, [_c('div', {
    staticClass: "lamp lamp--neon flicker",
    staticStyle: {
      "top": "20%"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "lamp lamp--neon",
    staticStyle: {
      "top": "55%"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "lamp lamp--brand",
    staticStyle: {
      "top": "85%"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3918ef7b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/user/Platforms.vue
// module id = 432
// module chunks = 1